<script setup lang="ts">
import type { PropertySize } from "~/classes/generated/interface"

defineProps({
  file: null,
  size: null
})

function dedupColoredTags(tags: Set<string>): Set<string> {
  const result = new Set<string>();
  const seen = new Set<string>();

  for (const tag of Array.from(tags).sort()) {
    const [base, suffix] = tag.split(':');
    const isDefault = !suffix || suffix === base;

    if (isDefault) {
      if (!seen.has(base)) {
        seen.add(base);
        result.add(tag);
      }
    } else {
      result.add(tag);
    }
  }
  return result;
}

</script>


<template>
  <div class="tags">
    <file-property-tag
      v-for="value in dedupColoredTags(file.tags())"
      :key="value"
      class="tag"
      :size
      :value
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.tags
  @apply flex gap-1 flex-wrap overflow-hidden py-0.5 px-1
</style>
